import React, { useState, useEffect } from "react";
import {
  Col,
  Row,
  Button,
  Input,
} from "reactstrap";
import { Autocomplete, InputAdornment, TextField } from "@mui/material";
import { getUserList } from "../../api/casp/user";
import { createProject, getAllProject } from "../../api/casp/project";
import { toast } from "react-toastify";
import ProjectComponent from "../../Components/casp/project/ProjectComponent";
import { PaginationComponent } from "../../Components/casp/common/PaginationComponent";
import { Role } from "../../constants/Role";
import { Action, DefaultPerPageValue } from "../../constants/Common";
import { useSelector } from "react-redux";
import notfound from "../../assets/images/not-found.jpg";
import { hasModulePermission } from "../../helpers/permission";
import Search from "../../Components/casp/common/Search";
import FormControl from "@mui/material/FormControl";
import SearchDropDownListPaginationComponent from "../../Components/casp/common/SearchDropDownPaginationList";
import { getAllPortfolios } from "../../api/casp/portfolio";
import dayjs from "dayjs";
import { Spinner } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { Skeleton } from "@mui/material";
import { Modules } from "../../constants/Module";
import { ucFirst } from '../../helpers/string_helper';
import { getProjectType } from "../../api/casp/projectType";
import { Helmet } from 'react-helmet';
import { getIconPath } from "../../helpers/file_helper";
import { filter } from 'lodash/collection';
import { get } from 'lodash/object';
import Drawer from '@mui/material/Drawer';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import { ProjectStatuses } from "../../constants/Status";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { withTranslation } from "react-i18next";
import AddProjectDrawer from "../../Components/casp/project/AddProjectDrawer";

const ProjectLists = (props) => {
  const [modal, setModal] = useState(false);
  const projectObject = {
    name: "",
    description: "",
    scope: "",
    country: "",
    state: "",
    city: "",
    technologyType: "",
    startDate: "",
    endDate: "",
    projectTypeId: "",
    projectCost: "",
    portfolioIds: "",
    projectAdminId: "",
    projectOwnerId: "",
    projectSponsorId: "",
  };
  const [projectList, setProjectList] = useState([]);
  const [portfolio,setPortfolio] = useState()
  const [triggerData, setTriggerData] = useState(+new Date());
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(DefaultPerPageValue);
  const [paginationObject, setPaginationObject] = useState({});
  const loggedInUser = useSelector((state) => state.Profile.user);
  const [projectCreationLoading, setProjectCreationLoading] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rightDrawer, setRightDrawer] = useState({
    right: false
  });


  const [excludeFilterIds, setExcludeFilterIds] = useState([{
    name: 'projectAdminId',
    value: []
  },
  {
    name: 'projectOwnerId',
    value: []
  },
  {
    name: 'projectSponsorId',
    value: []
  }]);

  const toggleDrawer = (anchor, open) => (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    formik.resetForm();
    setRightDrawer({ ...rightDrawer, [anchor]: open });
    setIsDrawerOpen(true)
  };

  const handleCloseDrawer = async (message) => {
    setIsDrawerOpen(false);
    if (message === "success") {
      setProjectList([]);
      page > 0
        ? setPage(0)
        : await fetchProjectList({ page: 1, perPage: rowsPerPage });
    }

    setRightDrawer({ right: false });
  };



  const toggle = () => {
    formik.resetForm();
    formik.setValues(formik.initialValues);

    setRightDrawer({ right: false });
  };

  useEffect(() => {
    fetchProjectList({ page: page + 1, perPage: rowsPerPage });
  }, [page, rowsPerPage,triggerData]);

  const projectValidation = Yup.object().shape({
    name: Yup.string()
      .strict(true)
      .trim(props.t('Must not include leading and trailing spaces'))
      .max(250, props.t("Name can not be greater than 250 characters"))
      .matches(/^(?=.*[a-zA-Z0-9])[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/? ]*$/, props.t("Name should be in proper type"))
      .required(props.t("Please enter project name")),
    description: Yup.string()
      .max(2000, props.t("Description can not be greater than 2000 characters"))
      .strict(true)
      .trim(props.t('Must not include leading and trailing spaces')),
    // .required(props.t("Please Enter description")),
    scope: Yup.string()
      .max(250, props.t("Scope can not be greater than 250 characters"))
      .strict(true)
      .trim(props.t('Must not include leading and trailing spaces')),
    // .required(props.t("Please Enter scope")),
    country: Yup.object()
      .required(props.t("Please Enter country")),
    state: Yup.object(),
    city: Yup.object(),
    technologyType: Yup.string()
      .strict(true)
      .trim(props.t('Must not include leading and trailing spaces'))
      .required(props.t("Please Enter technology type")),
    startDate: Yup.date().typeError(props.t("Given date is invalid type")).required(props.t("Please enter start date")),
    endDate: Yup.date()
      .typeError(props.t("Given date is invalid type"))
      .required(props.t("Please enter end date"))
      .min(Yup.ref("startDate"), props.t("End date cannot be before Start date")),
    portfolioIds: Yup.number().required(props.t("Please select incubator")),
    projectAdminId: Yup.string().required(props.t("Please select project manager"))
      .notOneOf([Yup.ref("projectOwnerId"), Yup.ref('projectSponsorId')], props.t("Must be a different project manager id")),
    projectOwnerId: Yup.string().required(props.t("Please select project owner"))
      .notOneOf([Yup.ref("projectAdminId"), Yup.ref('projectSponsorId')], props.t("Must be a different project owner id")),
    projectSponsorId: Yup.string().required(props.t("Please select project sponsor"))
      .notOneOf([Yup.ref("projectOwnerId"), Yup.ref('projectAdminId')], props.t("Must be a different project sponsor id")),
    projectCost: Yup.number()
      .strict(true)
      .min(0),
    // .required(props.t("Please enter project cost")),
    projectTypeId: Yup.number().required(props.t("Please select project type"))
  });

  const formik = useFormik({
    initialValues: {
      ...projectObject,
    },
    validationSchema: projectValidation,
    validateOnMount: true,
    onSubmit: (values) => {
      handleSubmit();
    },
  });

  /** Add new project */
  const handleSubmit = async () => {
    try {
      setProjectCreationLoading(true);
      const payload = {
        name: formik.values.name,
        description: formik.values.description,
        scope: formik.values.scope,
        country: formik.values.country.name,
        state: formik.values.state ? formik.values.state.name : '',
        city: formik.values.city ? formik.values.city.name : '',
        technologyType: formik.values.technologyType,
        companyId: loggedInUser?.company?.id,
        startDate: formik.values.startDate,
        endDate: formik.values.endDate,
        portfolioIds: formik.values.portfolioIds,
        projectAdminId: formik.values.projectAdminId,
        projectOwnerId: formik.values.projectOwnerId,
        projectSponsorId: formik.values.projectSponsorId,
        projectTypeId: formik.values.projectTypeId,
        projectCost: formik.values.projectCost ? formik.values.projectCost : 0.00
      };

      const response = await createProject(payload);
      if (response.statusCode === 200) {
        toast.success(response.data.message);
        setProjectList([]);
        toggle();
        page > 0
          ? setPage(0)
          : await fetchProjectList({ page: 1, perPage: rowsPerPage });
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setProjectCreationLoading(false);
      setExcludeFilterIds([{
        name: 'projectAdminId',
        value: []
      },
      {
        name: 'projectOwnerId',
        value: []
      },
      {
        name: 'projectSponsorId',
        value: []
      }])
    }
  };

  /** Fetch project list from api */
  const fetchProjectList = async (paginationData) => {
    try {
      setIsLoading(true);
      const filterFields = [];
      const filterInputs = [];

      // Add status filter
      if (props.status) {
        filterFields.push("status");
        filterInputs.push(props.status.join(","));
      }

      // Add portfolioId filter
      if (portfolio?.id) {
        filterFields.push("portfolioId");
        filterInputs.push(portfolio.id);
      }

      const params = {
        ...paginationData,
        ...(search && { search }),
        order: "updatedAt",
        direction: "desc",
        ...(filterFields.length && { filterFields }),
        ...(filterInputs.length && { filterInputs }),
      };


      if (
        ![
          Role.EPMO_MANAGER,
          Role.ROOT_ADMIN,
          Role.VICE_PRESIDENT,
          Role.PRESIDENT,
          Role.PROGRAM_MANAGER,
          Role.EPMO_OFFICER,
        ].includes(loggedInUser?.role?.name)
      ) {
        params.userId = loggedInUser.id;
      }

      const res = (await getAllProject(params)).data.data;
      if (res.data.length > 0) {
        let data =
          res.data.length > 0 &&
          res.data.map((project) => {
            return {
              color: project.color,
              label: project.name,
              status: project.status,
              id: project.id,
            };
          });
        setPaginationObject(res.meta);
        setProjectList(data);
      } else {
        setPaginationObject(res.meta);
        setProjectList([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  // Pagination Operation
  const handleChangePage = async (event, newPage) => {
    setProjectList([]);
    setPaginationObject({});
    setPage(newPage);
  };

  const handleChangeRowsPerPage = async (event) => {
    setProjectList([]);
    setPaginationObject({});
    const perPage = parseInt(event.target.value);
    setRowsPerPage(perPage);
    setPage(0);
  };

  // Global Search
  const globalSearch = async (params) => {
    setSearch(params.search);
    const response = await fetchProjectList(params);
    return response;
  };

  /** project list rendering */
  const projectListRendering = () => {
    const projectDetails = [];
    if (projectList.length === 0) {
      return (
        <React.Fragment>
          {projectList.length === 0 && !isLoading && (
            <img src={notfound} alt="No Data"></img>
          )}
          {isLoading && (
            <Col md={12} className="p-3">
              <Row className="mb-2">
                <Col md={6}>
                  <Skeleton
                    variant="rounded"
                    className="p-2 m-2 h-75"
                  ></Skeleton>
                </Col>
                <Col md={6}>
                  <Skeleton
                    variant="rounded"
                    className="p-2 m-2 h-75"
                  ></Skeleton>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={6}>
                  <Skeleton
                    variant="rounded"
                    className="p-2 m-2 h-75"
                  ></Skeleton>
                </Col>
                <Col md={6}>
                  <Skeleton
                    variant="rounded"
                    className="p-2 m-2 h-75"
                  ></Skeleton>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={6}>
                  <Skeleton
                    variant="rounded"
                    className="p-2 m-2 h-75"
                  ></Skeleton>
                </Col>
                <Col md={6}>
                  <Skeleton
                    variant="rounded"
                    className="p-2 m-2 h-75"
                  ></Skeleton>
                </Col>
              </Row>
            </Col>
          )}
        </React.Fragment>
      );
    }
    for (const eachProject of projectList) {
      projectDetails.push(
        <ProjectComponent projectDetail={eachProject} key={eachProject.id} />
      );
    }
    return projectDetails;
  };

  return (
    <React.Fragment>
      <Helmet
        onChangeClientState={(newState, addedTags) => {
          try {
            // Check if we added any new link[rel="icon"] elements.
            const newFaviconElems = filter(get(newState, 'linkTags', []), {
              rel: 'icon',
            })

            if (!newFaviconElems.length) {
              return
            }

            // Get the href of the last link element we just added, which
            // we assume is the most recently-added favicon.
            const newFaviconHref =
              newFaviconElems[newFaviconElems.length - 1].href

            // Remove all react-helmet link elements with rel="icon" that
            // do not have the href of our recently-added favicon.
            // If no other favicon elements exist, we don't have to do
            // anything.
            const existingFavicons = document.querySelectorAll(
              `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
            )

            if (existingFavicons.length) {
              existingFavicons.forEach(e => e.parentNode.removeChild(e))
            }

            // Remove and re-add the latest link element to make sure
            // the browser uses it.
            const newFaviconElem = document.querySelector(
              `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
            )

            if (newFaviconElem) {
              const newFavElement = newFaviconElem.cloneNode(true)
              newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(<DashboardOutlinedIcon />)}</svg>`
              )}`
              const parentElem = newFaviconElem.parentNode
              parentElem.removeChild(newFaviconElem)
              parentElem.appendChild(newFavElement)
            }
          } catch (e) {
            console.error(e)
          }
        }}
      >
        <title>{props.status && props.status.includes(ProjectStatuses.DRAFT) ? props.t('Pending Startups') : props.t('Approved Startups')}</title>
      </Helmet>
      <div className="d-flex justify-content-between align-items-center ongoingProjectsPg">
        <div>
          <h4 className="mb-0">{props.t("Startups")}</h4>
        </div>
        <div className="d-flex justify-content-end">
          <div className="me-2">
            <SearchDropDownListPaginationComponent
              label={props.t("Cohort")}
              sx={{
              width: 200,
              }}
              disabled={projectCreationLoading}
              searchEnabled={false}
              listCall={getAllPortfolios}
              disableClearable={!portfolio}
              defaultValue={portfolio}
              apiParams={{
                  order: "updatedAt",
                  direction: "desc",
                  ...(![
                      Role.PROJECT_MANAGER,
                      Role.EPMO_MANAGER,
                      Role.ROOT_ADMIN,
                      Role.VICE_PRESIDENT,
                      Role.PRESIDENT,
                      Role.PROGRAM_MANAGER,
                      Role.EPMO_OFFICER,
                      Role.MENTOR
                  ].includes(loggedInUser?.role?.name) && {
                      filterFields: "portfolioUser",
                      filterInputs: loggedInUser.id,
                  }),
              }}
              emitItem={(newValue) => {
                  setPortfolio(newValue);
                  setPage(0)
                  setTriggerData(+new Date());
              }}
            />
          </div>
          <div className="ongoingSearchField d-flex align-items-center">
          <div className="position-relative">
            <Search
              listCall={globalSearch}
              params={{
                ...(props?.status ? {
                  filterFields: ["status"],
                  filterInputs: [props.status]
                } : {}),
                page: 1,
                perPage: rowsPerPage,
              }}
            />
            <SearchOutlinedIcon />
          </div>
          <div className="ms-2">
            {loggedInUser?.role?.name === Role.EPMO_OFFICER && (
              <Button
                onClick={toggleDrawer("right", true)}
                className="w-100 main-login-btn btn btn-secondary d-flex align-items-center"
              >
                <i className="las la-plus d-inline-block me-2"></i>
                {props.t("New Startup")}
              </Button>
            )}
          </div>
          </div>
        </div>
      </div>
      <div className="ongoingProject d-flex my-4 w-100 flex-wrap justify-content-between">{projectListRendering()}</div>

      {isDrawerOpen && (
        <AddProjectDrawer
          isOpen={isDrawerOpen}
          handleClose={handleCloseDrawer}
        />
      )}

      {projectList.length > 0 && (
        <div className="ongoingProjPagination d-flex justify-content-center mt-3">
          <PaginationComponent
            paginationObject={paginationObject}
            page={page}
            handleChangePage={handleChangePage}
            rowsPerPage={rowsPerPage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </div>
      )}
    </React.Fragment>
  );
};

export default withTranslation()(ProjectLists);
